import styled, { css } from 'styled-components'
import { tokens, primitives } from '../../../assets/tokens'
import { safeAlpha } from '../../../utils/color'

const { color } = tokens

// Réplica de ActionButton (buttonVariant="outlined") del Storybook de Velora: neutro
// por defecto. Si quien lo usa pasa un `color` explícito, borde y texto van en ese color.
const RegularButtonOutlineStyled = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  && {
    min-height: 40px;
    font-family: ${tokens.typography.fontFamily.primary};
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    white-space: nowrap;
    color: ${props => props.color || primitives.neutral[600]};
    background: ${color.background.default};
    border-radius: 8px;
    box-shadow: none;
    padding: 10px 14px;
    outline: none;
    border: 1.5px solid ${props => props.color || primitives.neutral[300]};
    transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;

    :hover {
      background: ${props => (props.color ? safeAlpha(props.color, 0.08) : color.background.muted)};
      border-color: ${props => props.color || primitives.neutral[400]};
    }

    ${props =>
      props.styledType === 'reset' &&
      css`
        min-height: 0;
        background-color: transparent;
        color: ${color.text.primary};
        padding: 0;
        border: 0;
        font-weight: 500;
        font-size: 14px;

        :hover {
          background-color: transparent;
        }
      `};

    ${props =>
      props.styledType === 'invert' &&
      css`
        background-color: transparent;
        :hover {
          background-color: transparent;
        }
      `};

    ${props =>
      props.disabled === true &&
      css`
        cursor: default;
        background: ${color.background.muted};
        color: ${primitives.neutral[400]};
        border-color: ${primitives.neutral[200]};
        :hover {
          background: ${color.background.muted};
          border-color: ${primitives.neutral[200]};
        }
      `};
  }
`

export default RegularButtonOutlineStyled
